import { ImageWrapper } from '../../common/wrappers/ImageWrapper';
import Button from '../../common/buttons/Button';
import React, { useState } from 'react';
import introMap from '../../../assets/images/games/zdar-kids-game/intro-map.webp';
import parse from 'html-react-parser';

type Props = {
    text: string;
    title?: string;
    previewText?: string;
    audioOpened?: boolean;
    setAudioOpened?: (a: boolean) => void;
    audio?: any;
    emptyImage?: boolean;
    currentStep?: number;
};

export default function ZdarKidsTaskText({
    text,
    previewText,
    audio,
    audioOpened,
    setAudioOpened,
    title,
    emptyImage,
    currentStep,
}: Props) {
    const [open, setOpen] = useState(false);

    const formattedText = text.replace('*playIcon*', `<img src='/common/audio-play.gif' alt="play" width=30 />`);
    const formattedPreviewText = previewText?.replace(
        '*playIcon*',
        `<img src='/common/audio-play.gif' alt="play" width=30 />`,
    );
    const showImageInText = () => {
        if (emptyImage) {
            return (
                <div className="image-in-text-wrapper">
                    <div className="task-title-audio-icon">
                        {audio && !audioOpened && (
                            <img
                                src="/common/audio-play.gif"
                                alt="play"
                                onClick={() => (setAudioOpened ? setAudioOpened(true) : null)}
                                width={34}
                            />
                        )}
                    </div>
                    <div className="task-title-audio-icon">
                        {audio && !audioOpened && <div className="task-title-placeholder" />}
                    </div>
                </div>
            );
        }
        return <React.Fragment />;
    };
    if (currentStep === 1) {
        return (
            <React.Fragment>
                <div className="zdar-cipher-text-wrapper">
                    <div className="zdar-cipher-text">{text && parse(formattedText)}</div>
                </div>
                <ImageWrapper src={introMap} alt="mapa" allowLightbox={false} />
            </React.Fragment>
        );
    }

    if (!previewText) {
        return (
            <div className={title ? 'task-text' : 'task-text task-text--standalone'}>
                {showImageInText()}
                {parse(formattedText)}
            </div>
        );
    } else {
        return (
            <div className={title ? 'task-text' : 'task-text task-text--standalone'}>
                {open && (
                    <div className="zdar-task-full">
                        {showImageInText()}
                        {parse(formattedText)}
                    </div>
                )}
                {!open && (
                    <div className="zdar-task-preview">
                        {showImageInText()}
                        {parse(formattedPreviewText + '&hellip;')}
                        <Button onClick={() => setOpen(true)} className="primary-button">
                            Zobrazit celý text
                        </Button>
                    </div>
                )}
            </div>
        );
    }
}
